import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, getConsultees, GetConsulteesResponse, QueryDefaults } from 'api';

export const useConsultees = (): QueryObserverResult<GetConsulteesResponse> =>
  useQuery([API_QUERY_KEYS.getConsultees], getConsultees, QueryDefaults);
